import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../../axios";
import {
  // Container,
  Box,
  Backdrop,
  Alert,
  Snackbar,
  CircularProgress,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Icon,
  Divider,
  Dialog,
  DialogContent,
  // DialogContentText,
  // DialogTitle,
  DialogActions,
  Button,
  Checkbox,
  TextField,
  MenuItem,
  Grid,
  Switch,
  Tooltip,
  DialogTitle,
} from "@mui/material";

function InstagramInsightsApprovalPage() {
  const { ref, code } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [insightsData, setInsightsData] = useState({});
  const [statusDialog, setStatusDialog] = useState(false);

  async function getInsights(postID) {
    setShowLoading(true);
    await axios
      .get(`sm/instagram/approval/${postID}/insights.json`)
      .then((result) => {
        setShowLoading(false);
        console.log(result.data.data);
        if (result.data.status === "success") {
          // setSeverity("success");
          setInsightsData(result.data.data.insights);
          setStatusDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });
  }

  return (
    <>
      <Box mb={5}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {errorMsg}
          </Alert>
        </Snackbar>
      </Box>
      <Dialog open={statusDialog} fullWidth maxWidth="sm">
        <DialogTitle>Post Insight</DialogTitle>
        <DialogContent>
          <Box align="left">
            <Box mt={0}>
              <Typography variant="h6">
                Reach: {insightsData.reach}
                <br />
                Views: {insightsData.views}
                <br />
                Likes: {insightsData.likes}
                <br />
                Comments: {insightsData.comments}
                <br />
                Shares: {insightsData.shares}
                <br />
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStatusDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      <Box
        mt={10}
        sx={{ width: "100%", maxWidth: "800px", margin: "25px auto" }}
      >
        <Paper>
          <Box p={3}>
            <Box mb={3} align="center">
              <Typography variant="h6">Instagram Media Insights</Typography>
            </Box>
            <ListItem>
              <ListItemText
                primary={<Typography>Post ID: 18066955150914094</Typography>}
                secondary={
                  <Typography>
                    <a
                      href="https://www.instagram.com/p/DG8K4WAIUcS"
                      target="_blank"
                    >
                      https://www.instagram.com/p/DG8K4WAIUcS
                    </a>
                  </Typography>
                }
              />
              <Box>
                <Button
                  variant="contained"
                  size="small"
                  color="info"
                  onClick={() => getInsights("18066955150914094")}
                >
                  Get Insights
                </Button>
              </Box>
            </ListItem>
            <ListItem>
              <ListItemText
                primary={<Typography>Post ID: 18155462500355294</Typography>}
                secondary={
                  <Typography>
                    <a
                      href="https://www.instagram.com/p/DGkTRLcNzyA"
                      target="_blank"
                    >
                      https://www.instagram.com/p/DGkTRLcNzyA
                    </a>
                  </Typography>
                }
              />
              <Box>
                <Button
                  variant="contained"
                  size="small"
                  color="info"
                  onClick={() => getInsights("18155462500355294")}
                >
                  Get Insights
                </Button>
              </Box>
            </ListItem>
            <ListItem>
              <ListItemText
                primary={<Typography>Post ID: 18057030767056307</Typography>}
                secondary={
                  <Typography>
                    <a
                      href="https://www.instagram.com/p/DFhYlCvpQW7"
                      target="_blank"
                    >
                      https://www.instagram.com/p/DFhYlCvpQW7
                    </a>
                  </Typography>
                }
              />
              <Box>
                <Button
                  variant="contained"
                  size="small"
                  color="info"
                  onClick={() => getInsights("18057030767056307")}
                >
                  Get Insights
                </Button>
              </Box>
            </ListItem>
          </Box>
        </Paper>
      </Box>
    </>
  );
}

export default InstagramInsightsApprovalPage;
